/* 🤖 this file was generated by svg-to-ts */
export const iconSuccess32: {
  name: 'success_32';
  data: string;
} = {
  name: 'success_32',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32"><path d="M16 0c8.822 0 16 7.178 16 16s-7.178 16-16 16S0 24.822 0 16 7.178 0 16 0Zm0 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2Zm7.707 9.293a.999.999 0 0 1 0 1.414l-8.084 8.087a2.992 2.992 0 0 1-2.122.877 2.986 2.986 0 0 1-2.121-.877l-2.587-2.587a.999.999 0 1 1 1.414-1.414l2.587 2.587a1.003 1.003 0 0 0 1.415-.001l8.084-8.086a.999.999 0 0 1 1.414 0Z"/></svg>`,
};
